/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ico-pieces-touchees': {
    width: 16,
    height: 16,
    viewBox: '0 0 18 18',
    data: '<path pid="0" d="M17.82 5.3l-3.57-2.17V.38a.38.38 0 00-.38-.38h-1.5a.38.38 0 00-.37.38v1.38L9.19.05a.37.37 0 00-.38 0L.18 5.3a.4.4 0 00-.18.43.39.39 0 00.38.27h1.87v11.62a.38.38 0 00.38.38h7.12v-5.63a.38.38 0 01.37-.37h3a.38.38 0 01.38.37V18h1.87a.38.38 0 00.38-.38V6h1.87a.39.39 0 00.38-.27.4.4 0 00-.18-.43zM8.25 15.37a.38.38 0 01-.37.38h-3a.38.38 0 01-.38-.38v-3a.38.38 0 01.38-.37h3a.38.38 0 01.37.37zm0-5.25a.38.38 0 01-.37.38h-3a.38.38 0 01-.38-.38v-3a.38.38 0 01.38-.38h3a.38.38 0 01.37.38zM9 4.5A1.5 1.5 0 1110.5 3 1.5 1.5 0 019 4.5zm4.5 5.62a.38.38 0 01-.38.38h-3a.38.38 0 01-.37-.38v-3a.38.38 0 01.37-.38h3a.38.38 0 01.38.38z"/>'
  }
})
